import { render } from "./PrintBaptismCertificate.vue?vue&type=template&id=9c226764"
import script from "./PrintBaptismCertificate.vue?vue&type=script&lang=js"
export * from "./PrintBaptismCertificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__